// Customised https://github.com/lifeomic/axios-fetch so it works on React Native
import "cross-fetch/polyfill"
import {cloneDeep, identity, mapKeys} from "lodash"

/**
 * A Fetch WebAPI implementation based on the Axios client
 */
async function axiosFetch(axios, transfomer, input, init = {}) {
  // Convert the `fetch` style arguments into a Axios style config
  const axiosTransformer = transfomer || identity

  const requestHeaders = cloneDeep(init.headers) || {}
  const lowerCasedHeaders = mapKeys(init.headers, function (value, key) {
    return key.toLowerCase()
  })

  if (!("content-type" in lowerCasedHeaders)) {
    requestHeaders["Content-Type"] = "text/plain;charset=UTF-8"
  }

  // Handle different body types properly
  let bodyData = init.body

  if (init.body && typeof init.body !== "string") {
    if (init.body instanceof FormData) {
      // Keep FormData as-is for file uploads
      bodyData = init.body
      // Remove content-type header so browser/axios can set it
      delete requestHeaders["Content-Type"]
    } else {
      // Convert other objects to string
      bodyData = String(init.body)
    }
  } else if (init.body) {
    bodyData = init.body // already a string
  }

  const config = axiosTransformer(
    {
      url: input,
      method: init.method || "GET",
      data: bodyData,
      headers: requestHeaders,
      validateStatus: () => true
    },
    input,
    init
  )
  const result = await axios.request(config)

  // Convert the Axios style response into a `fetch` style response
  const responseBody = typeof result.data === "object" ? JSON.stringify(result.data) : result.data

  const headers = new Headers()
  Object.entries(result.headers).forEach(function ([key, value]) {
    headers.append(key, value)
  })

  return new Response(responseBody, {
    status: result.status,
    statusText: result.statusText,
    headers
  })
}

export default function buildAxiosFetch(axios, axiosTransformer) {
  return axiosFetch.bind(undefined, axios, axiosTransformer)
}
